import { useEffect, useRef, useContext } from 'react'
import { Chart, registerables } from 'chart.js'
import { useTheme, Theme } from '@material-ui/core'
import { InstallsContext } from 'src/context/gamePlayInsights/installs'
import { CohortsContext } from 'src/context/gamePlayInsights/cohorts'

const View = (props: any) => {
  const theme: Theme = useTheme()
  const chart = useRef<any>()
  const { state } = useContext(InstallsContext)
  const { state: cohortsState } = useContext(CohortsContext)

  // effects
  useEffect(() => {
    if (!chart.current) {
      const chartEl: any = document.getElementById('dashChart' + props.id)
      // chartEl.style.height = '400px'
      if (chartEl) {
        Chart.register(...registerables)
        Chart.defaults.color =
          theme.palette.mode === 'dark' ? '#FFFFFF' : '#1D3353'
        chart.current = new Chart(chartEl.getContext('2d'), {
          type: cohortsState.newChartType === 'Graph' ? 'line' : 'bar',
          data: {
            labels: [1, 2, 3, 4, 5],
            datasets: [
              {
                label: 'all',
                data: [0, 0, 0, 0, 0],
                pointRadius: 2.5,
                borderColor: '#FF8E00',
                backgroundColor: '#FF8E00',
              },
            ],
          },
          options: {
            maintainAspectRatio: false,
            scales: {
              y: {
                min: 0,
                stacked: cohortsState.newChartType === 'Graph' ? false : true,
                grid: {
                  color:
                    theme.palette.mode === 'dark'
                      ? 'rgba(244, 243, 241, 0.4)'
                      : '#E6E6E6',
                  borderColor:
                    theme.palette.mode === 'dark'
                      ? 'rgba(244, 243, 241, 0.4)'
                      : '#E6E6E6',
                },
              },
              x: {
                stacked: true,
                grid: {
                  drawOnChartArea: false,
                },
              },
            },
            plugins: {
              legend: {
                display: false,
              },
            },
          },
        })
      }
    }
    let newData: any = state.data
    if (!newData || !newData.datasets) return
    if (state.checkedChartLine.length) {
      const temp: any = { datasets: [], labels: newData.labels }
      temp.datasets = newData.datasets.filter((item: any) =>
        state.checkedChartLine.includes(item.label)
      )
      newData = temp
    } else {
      newData = { datasets: [], labels: newData.labels }
    }
    chart.current.data = newData
    chart.current?.update()
    return function willUnmount() {
      if (chart.current) {
        chart.current.clear()
        chart.current.destroy()
        chart.current = undefined
      }
    }
    // eslint-disable-next-line
  }, [
    state.data,
    state.checkedChartLine,
    cohortsState.newChartType,
    theme.palette.mode,
  ])
  // returns
  return (
    <canvas id={'dashChart' + props.id} width={props.width} height="396px" />
  )
}

export default View
